import { ERentioFormField } from "../../components/components/Form";
import { getName } from "../../redux/contact/contact.utils";
import { getValue } from "../../redux/form/form.utils";
import { ERentDepositProvider } from "../../types/rentDeposit.types";
import { startOfDay, endOfDay, isEqual, isBefore, isAfter, } from "../../utils/date-fns.utils";
import { formatDate } from "../../utils/date.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getMappedCountries } from "../../utils/location/location.utils";
import { EField } from "./schema.releaseRentDeposit.types";
import { EBanqupRentioDocumentType } from "./schema.releaseRentDeposit.types";
import { getNavigationTitle, getIdDocumentsSummary, getPayer, isFileSizeValid, } from "./schema.releaseRentDeposit.utils";
var NOW = new Date();
var END_OF_DAY = endOfDay(NOW);
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a, _b;
        var _c;
        var isBanqupMigration = ((_c = extraData.rentDeposit) === null || _c === void 0 ? void 0 : _c.provider) === ERentDepositProvider.Migrated;
        var payer = getPayer(extraData.relatedContract);
        return {
            required: [EField.PayerIdentityDocuments],
            properties: (_a = {},
                _a[EField.Header + "8"] = {
                    default: undefined,
                    showIf: function (_) { return isBanqupMigration; },
                },
                _a[EField.PayerIdentityDocuments] = {
                    // @ts-ignore
                    default: (function () {
                        var _a;
                        return [
                            (_a = {},
                                _a[EField.PayerIdentityDocumentAccountId] = payer === null || payer === void 0 ? void 0 : payer.account.id,
                                _a[EField.DocumentType] = EBanqupRentioDocumentType.IdCard,
                                _a.contact = payer === null || payer === void 0 ? void 0 : payer.account,
                                _a),
                        ];
                    })(),
                    showIf: function (_) { return isBanqupMigration; },
                    type: "array",
                    items: {
                        type: "object",
                        required: [
                            EField.IdentityDocumentIdentityFrontDocumentId,
                            EField.IdentityDocumentIdentityBackDocumentId,
                            EField.DateOfExpiry,
                            EField.DocumentNumber,
                            EField.DateOfIssuance,
                            EField.CountryOfIssuance,
                        ],
                        properties: (_b = {},
                            _b[EField.PayerIdentityDocumentAccountId] = {},
                            _b[EField.DocumentType] = {
                                default: EBanqupRentioDocumentType.IdCard,
                                // @ts-ignore
                                options: [
                                    EBanqupRentioDocumentType.IdCard,
                                    EBanqupRentioDocumentType.Passport,
                                ].map(function (id) { return ({
                                    id: id,
                                    value: getLocalizedText("rent_deposit.documentType.".concat(id.toLowerCase())),
                                }); }),
                            },
                            _b[EField.IdentityDocumentIdentityFrontDocumentId] = {
                                minLength: 1,
                            },
                            _b[EField.IdentityDocumentIdentityBackDocumentId] = { minLength: 1 },
                            _b[EField.DocumentNumber] = {
                                default: getValue(EField.DocumentNumber, initialValues, defaultValues),
                            },
                            _b[EField.DateOfIssuance] = {
                                default: getValue(EField.DateOfIssuance, initialValues, defaultValues),
                            },
                            _b[EField.DateOfExpiry] = {
                                default: getValue(EField.DateOfExpiry, initialValues, defaultValues),
                            },
                            _b[EField.CountryOfIssuance] = {
                                default: getValue(EField.CountryOfIssuance, initialValues, defaultValues),
                                // @ts-ignore
                                options: getMappedCountries(),
                            },
                            _b),
                    },
                    uniqueItems: true,
                },
                _a),
        };
    };
};
export var uiSchema = function (extraData) {
    var _a, _b;
    return _a = {
            "rentio:title": getLocalizedText("rent_deposit.identity_documents.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header + "8"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("rent_deposit.banqup_identity_documents.heading"),
        },
        _a[EField.PayerIdentityDocuments] = {
            "ui:field": ERentioFormField.Array,
            title: getLocalizedText("rent_deposit.banqup_identity_documents.heading"),
            "ui:options": {
                orderable: false,
                addable: false,
                removable: false,
            },
            getItemTitle: function (itemData) {
                return itemData.contact && getName(itemData.contact);
            },
            items: (_b = {},
                _b[EField.PayerIdentityDocumentAccountId] = { "ui:widget": "hidden" },
                _b[EField.DocumentType] = {
                    "ui:field": ERentioFormField.SegmentedControl,
                    title: getLocalizedText("rent_deposit.documentType.label"),
                    formatSummary: function (formData) {
                        return getLocalizedText("rent_deposit.documentType.".concat(formData === null || formData === void 0 ? void 0 : formData.toLowerCase()));
                    },
                },
                _b[EField.IdentityDocumentIdentityFrontDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: ["image/jpeg", "image/jpg"],
                    multiple: false,
                    title: getLocalizedText("rent_deposit.identity_documents.front_document.label"),
                },
                _b[EField.IdentityDocumentIdentityBackDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: ["image/jpeg", "image/jpg"],
                    multiple: false,
                    title: getLocalizedText("rent_deposit.identity_documents.back_document.label"),
                },
                _b[EField.DateOfExpiry] = {
                    "ui:field": ERentioFormField.Date,
                    title: getLocalizedText("rent_deposit.id_expiry_date.label"),
                    formatSummary: function (input) { return input && formatDate(input); },
                },
                _b[EField.DocumentNumber] = {
                    "ui:field": ERentioFormField.Text,
                    title: getLocalizedText("rent_deposit.document_number.label"),
                },
                _b[EField.CountryOfIssuance] = {
                    "ui:field": ERentioFormField.DropdownSelect,
                    title: getLocalizedText("rent_deposit.country_of_issuance.label"),
                },
                _b[EField.DateOfIssuance] = {
                    "ui:field": ERentioFormField.Date,
                    title: getLocalizedText("rent_deposit.date_of_issuance.label"),
                    formatSummary: function (input) { return input && formatDate(input); },
                },
                _b),
            formatSummary: function (docs) { return getIdDocumentsSummary(docs); },
        },
        _a;
};
export var getValidate = function () { return function (formData, errors) {
    var allowedMBS = 10;
    var _a = formData, _b = EField.PayerIdentityDocuments, _c = _a[_b], payerIdentityDocuments = _c === void 0 ? [] : _c;
    if (payerIdentityDocuments.length > 0) {
        var _d = payerIdentityDocuments[0], _e = _d.identityBackDocument, identityBackDocument = _e === void 0 ? [] : _e, _f = _d.identityFrontDocument, identityFrontDocument = _f === void 0 ? [] : _f, dateOfIssuance = _d.dateOfIssuance, dateOfExpiry = _d.dateOfExpiry;
        var _g = (errors[EField.PayerIdentityDocuments] || [])[0] || {}, dateOfIssuanceError = _g.dateOfIssuance, dateOfExpiryError = _g.dateOfExpiry, identityBackDocumentError = _g.identityBackDocument, identityFrontDocumentError = _g.identityFrontDocument;
        if (identityFrontDocument.length > 0) {
            if (!isFileSizeValid(identityFrontDocument[0], allowedMBS)) {
                identityFrontDocumentError.addError(getLocalizedText("form.create_rent_deposit.banqup_id_doc.max_file_size.error", { fileSize: "10MB" }));
            }
        }
        if (identityBackDocument.length > 0) {
            if (!isFileSizeValid(identityBackDocument[0], allowedMBS)) {
                identityBackDocumentError.addError(getLocalizedText("form.create_rent_deposit.banqup_id_doc.max_file_size.error", { fileSize: "10MB" }));
            }
        }
        if (isAfter(dateOfIssuance, END_OF_DAY) && dateOfIssuanceError) {
            dateOfIssuanceError.addError(getLocalizedText("form.create_rent_deposit.payer_id_doc.date_of_issue.error"));
            return errors;
        }
        if (isEqual(startOfDay(dateOfExpiry), startOfDay(dateOfIssuance)) &&
            dateOfExpiryError &&
            dateOfIssuanceError) {
            dateOfExpiryError.addError(getLocalizedText("form.create_rent_deposit.payer_id_doc.date_of_expiry_same_as_date_of_issuance.error"));
            return errors;
        }
        if (isBefore(dateOfExpiry, dateOfIssuance) && dateOfExpiryError) {
            dateOfExpiryError.addError(getLocalizedText("form.create_rent_deposit.payer_id_doc.date_of_expiry_before_date_of_issuance.error"));
        }
        return errors;
    }
    return errors;
}; };
